















































































































































































/* tslint:disable:no-console */
import Vue from 'vue';
import { Component, Prop, Watch, Model } from 'vue-property-decorator';
import { PublicAccount, NetworkType, TransferTransaction } from 'nem2-sdk';
import { ApostilleAccount } from 'apostille-library';
import Scanner from '@/components/scanner/Scanner.vue';
import NoScanner from '@/components/scanner/NoScanner.vue';
import DialogWithCloseButton from '@/components/scanner/DialogWithCloseButton.vue';
import DialogMobile from '@/components/scanner/DialogMobile.vue';
import FrameBox from '@/components/scanner/FrameBox.vue';
import FlatButtonWithIcon from '@/components/FlatButtonWithIcon.vue'; // @ is an alias to /src
import LuxtagApi from '@/api';

@Component({
  components: {
    Scanner,
    NoScanner,
    DialogMobile,
    DialogWithCloseButton,
    FrameBox,
    FlatButtonWithIcon,
  },
})
export default class Verifier extends Vue {
    @Prop({ default: false }) public open!: boolean;
    @Prop({ default: false }) public refresh!: boolean;
    @Prop() public eventId!: number;

    // show: indicator to show verifier dialog
    public show = this.open;
    public fake = false;
    public genuine = false;
    public verified = false;
    public error = '';
    public errorTimeout = 6000;
    public snackError = false;

    // view: indicator to change the content
    public view = 'illustration';

    // showMobileScanner: indicator to show mobile scanner dialog
    public showMobileScanner = false;

    public scanner = true;
    public isCameraShow = true;
    public cameraPaused = false;
    public mobileCameraHeight = 680;
    public mobileCameraWidth = 480;
    public isMobile = false;
    public illustrationCustomStyle = {
      height: '0px',
    };

    public prevEventId = 0;
    public prevDecode = '';

    @Watch('open')
    public onOpenChange(val: boolean) {
      // console.log(this.eventId);
      this.show = val;
      if (val) {
        // every time it's open it will always open illustration
        // this.view = 'illustration';
        this.showScanner();
      }
    }

    @Watch('show')
    public onShowChange(val: boolean) {
      if (!val) {
        // if it close then
        // emit to parent component to change the prop
        this.$emit('update:open', false);
        this.scanner = true;
      }
    }

    @Watch('refresh')
    public onRefreshChange(val: boolean) {
      // console.log('refresh component: ', val);
      if (!val) {
        // if it close then
        // emit to parent component to change the prop
        this.$emit('update:refresh', false);
      }
    }

    public changeView(view: string) {
      this.view = view;
      if (this.isMobile) {
        this.showMobileScanner = false;
      }
    }

    public showScanner() {
      if (this.isMobile) {
        // show mobile scanner
        this.showMobileScanner = true;
      } else {
        // show desktop scanner
        this.view = 'scanner';
      }
    }

    public onSuccess() {
      this.genuine = false;
      this.$emit('update:refresh', true);
      // this.navigate(`/detail/${this.eventId}`, true);
    }

    public onFailed() {
      this.fake = false;
      this.$emit('update:refresh', true);
      // this.navigate(`/detail/${this.eventId}`, true);
    }

    public onDecode(decode: string) {
      const that = this;
      this.$store.commit('MUTATE_LOADER', true);
      this.$emit('update:open', false);

      let decodedCode = '';

      for (let i = 0; i < decode.length; i++) {
        // if (decode.charAt(i) === ':') {
        //   break;
        // }
        decodedCode = decodedCode + decode.charAt(i);
      }

      console.log('DecodedCode:' +decode);
      console.log('DecodedCode2:' +decodedCode);

      // console.log(this.prevEventId, this.prevDecode);
      if (this.eventId === this.prevEventId && decodedCode === this.prevDecode) {
        this.error = 'Member code has already been scanned.';
        console.log('ALREADY SCAN');
        this.fake = true;
        this.snackError = true;
        this.$store.commit('MUTATE_LOADER', false);
      } else {
        console.log('OH SNAP');
        const pattern = /^(0x|0X)?[a-fA-F0-9]+$/;
        // if (!pattern.test(decodedCode) && decodedCode.length !== 64) {
        //   // not hex pattern
        //   this.$store.commit('MUTATE_LOADER', false);
        //   this.error = 'Invalid QR Code.';
        //   this.fake = true;
        //   console.log('FAKE');
        // } else {
          const data = {
            event_id: this.eventId,
            uuid: decodedCode
          };
          console.log('DOING STUFF');

          LuxtagApi.transaction.create(data)
            .then((response) => {
              this.$store.commit('MUTATE_LOADER', false);
              this.genuine = true;
              this.prevEventId = this.eventId;
              this.prevDecode = decodedCode;
              console.log('WORK AH');
            })
            .catch((e) => {
              this.$store.commit('MUTATE_LOADER', false);
              console.log('ERROR STUPID');
              e.response.data.message ? this.error = e.response.data.message : this.error = e;
              this.fake = true;
              this.snackError = true;
            });
        // }
      }
    }

    public closeDialogScanner() {
      this.showMobileScanner = false;
    }

    public mounted() {
      const that = this;
      this.onResize();
      window.addEventListener('resize', this.onResize, { passive: true });
      this.$on('fake', () => {
        that.fake = true;
      });
    }

    public onResize() {
      let illustrationHeight;
      this.mobileCameraHeight = window.innerHeight;
      this.mobileCameraWidth = window.innerWidth;

      if (window.innerWidth < this.$vuelux.breakpoint.tablet) {
        // below tablet breakpoint
        illustrationHeight = `${window.innerHeight * 65 / 100}px`;
        this.isMobile = true;
      } else {
        // desktop breakpoint
        illustrationHeight = '430px';
        this.isMobile = false;
      }
      this.illustrationCustomStyle.height = illustrationHeight;
    }

    public navigate(route: string, replace = false) {
      if (replace) {
        this.$router.replace(route);
      } else {
        this.$router.push(route);
      }
    }

    get minHeightScanner(): number {
      if (this.mobileCameraHeight < 480) {
        return this.mobileCameraHeight;
      } else {
        return 480;
      }
    }

    get minWidthScanner(): number {
      if (this.mobileCameraWidth < 360) {
        return this.mobileCameraWidth;
      } else {
        return 360;
      }
    }

    get headerTitle() {
      if (this.view === 'illustration') {
        return 'You are about to scan a QR Code';
      } else if (this.view === 'scanner') {
        return 'Scan the member’s QR Code';
      } else if (this.view === 'no-scanner') {
        return 'You are about to authenticate a member';
      } else {
        return 'We have not specified the title yet';
      }
    }
}
